export default class AuthDTO {
    password = ""
    username = ""
}